// src/Components/ShippingForm/countries.js

const COUNTRY_CODES = [
  "AF","AL","DZ","AS","AD","AO","AI","AQ","AG","AR","AM","AW","AU","AT","AZ",
  "BS","BH","BD","BB","BY","BE","BZ","BJ","BM","BT","BO","BA","BW","BR","BN",
  "BG","BF","BI","KH","CM","CA","CV","KY","CF","TD","CL","CN","CX","CC","CO",
  "KM","CG","CD","CK","CR","CI","HR","CU","CY","CZ","DK","DJ","DM","DO","EC",
  "EG","SV","GQ","ER","EE","ET","FK","FO","FJ","FI","FR","GF","PF","GA","GM",
  "GE","DE","GH","GI","GR","GL","GD","GP","GU","GT","GG","GN","GW","GY","HT",
  "HN","HK","HU","IS","IN","ID","IR","IQ","IE","IM","IL","IT","JM","JP","JE",
  "JO","KZ","KE","KI","KP","KR","KW","KG","LA","LV","LB","LS","LR","LY","LI",
  "LT","LU","MO","MG","MW","MY","MV","ML","MT","MH","MQ","MR","MU","YT","MX",
  "FM","MD","MC","MN","ME","MS","MA","MZ","MM","NA","NR","NP","NL","NC","NZ",
  "NI","NE","NG","NU","NF","MK","MP","NO","OM","PK","PW","PS","PA","PG","PY",
  "PE","PH","PL","PT","PR","QA","RE","RO","RU","RW","BL","SH","KN","LC","MF",
  "PM","VC","WS","SM","ST","SA","SN","RS","SC","SL","SG","SX","SK","SI","SB",
  "SO","ZA","GS","SS","ES","LK","SD","SR","SJ","SZ","SE","CH","SY","TW","TJ",
  "TZ","TH","TL","TG","TK","TO","TT","TN","TR","TM","TC","TV","UG","UA","AE",
  "GB","US","UY","UZ","VU","VA","VE","VN","VG","VI","WF","EH","YE","ZM","ZW"
];

const displayNames = new Intl.DisplayNames(["en"], { type: "region" });

export const COUNTRIES = COUNTRY_CODES
  .map((code) => ({ code, name: displayNames.of(code) || code }))
  .sort((a, b) => (a.name || "").localeCompare(b.name || ""));